import styled from 'styled-components';
import { breakpoints } from 'src/styles/theme';
import { WallboxSummaryStyled } from '../WallboxSummaryStyled';
import { rem } from 'polished';

export const WallboxSummaryAP = styled(WallboxSummaryStyled)`
   
`;
